import { CUSTOMER, NEWSLETTER_AGREEMENT, LEGAL_AGREEMENT } from "./field-names";
import { defaultValues as customerDataDefaultValues } from "../_sub-forms/customer-data/default-values";
import { defaultValues as legalAgreementDefaultValues } from "../_sub-forms/legal-agreement/default-values";
import { defaultValues as newsletterAgreementDefaultValues } from "../_sub-forms/newsletter-agreement/default-values";
export const defaultValues = {
    [CUSTOMER]: customerDataDefaultValues,
    [NEWSLETTER_AGREEMENT]: newsletterAgreementDefaultValues,
    [LEGAL_AGREEMENT]: legalAgreementDefaultValues
};
